/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { UserId } from "../../commons/types/UserId";
import { UserConfig } from "./UserConfig";
export const User = core.serialization
    .object({
    id: UserId,
    idp: core.serialization.string(),
    idpRef: core.serialization.string().optional(),
    metadata: core.serialization.record(core.serialization.string(), core.serialization.any()),
    createdAt: core.serialization.date(),
    updatedAt: core.serialization.date(),
    lastSeenAt: core.serialization.date().optional(),
    dashboard: core.serialization.number().optional(),
})
    .extend(UserConfig);
